import { Card } from "@/components/Card";

interface StepItem {
  label: string;
  value?: string;
}

interface MarisolNumberedCardProps {
  step: number;
  title: string;
  items: StepItem[];
  image?: string;
}

export const MarisolNumberedCard = ({
  step,
  title,
  items,
  image,
}: MarisolNumberedCardProps) => {
  return (
    <div className="relative">
      <Card
        rest
        noPadding
        rounded="rounded-2xl"
        className={`!bg-green-900 border-4 border-[#71c056] text-white p-5 md:max-w-xl h-full${image ? " lg:pr-52" : ""}`}
      >
        <div className="flex items-start gap-3 mb-5">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#71c056] flex items-center justify-center text-white font-bold text-sm">
            {step}.
          </div>
          <h3 className="text-white font-semibold text-base leading-snug">
            {title}
          </h3>
        </div>

        <ul className="space-y-4">
          {items.map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="mt-1.5 flex-shrink-0 w-2.5 h-2.5 rounded-full bg-yellow-400" />
              <div>
                <p className="text-white/70 text-sm">{item.label}</p>
                {item.value && (
                  <p className="text-white/70 text-sm">{item.value}</p>
                )}
              </div>
            </li>
          ))}
        </ul>
      </Card>

      {image && (
        <div className="hidden lg:block absolute right-0 -top-8 -bottom-8">
          <img
            src={image}
            alt="app preview"
            className="h-full w-auto drop-shadow-2xl"
          />
        </div>
      )}
    </div>
  );
};
